import React, { useState } from "react";
import PropTypes from "prop-types";
import { Tooltip } from "@mui/material";

export default function HoverText(props) {
  const ref = React.useRef(null);
  const [open, setOpen] = useState(false);

  const handleClose = () => {
    setOpen(false);
  };

  const handleOpen = () => {
    setOpen(true);
  };

  const mouseEnter = () => {
    ref.current.focus();
  };
  const mouseLeave = () => {
    ref.current.blur();
  };

  return (
    <Tooltip
      ref={ref}
      open={open}
      onClose={handleClose}
      onOpen={handleOpen}
      onKeyDown={(e) => {
        if (e.key === "Escape") {
          e.stopPropagation();
          handleClose();
        }
      }}
      onMouseEnter={mouseEnter}
      onMouseLeave={mouseLeave}
      title={
        props.html === "true" ? (
          <div dangerouslySetInnerHTML={{ __html: props.content }} />
        ) : (
          props.content
        )
      }
      enterDelay={props.delay || 400}
      leaveDelay={200}
      placement={props.direction || "top"}>
      {props.children}
    </Tooltip>
  );
}

HoverText.propTypes = {
  content: PropTypes.string.isRequired,
  html: PropTypes.string,
  direction: PropTypes.string,
  delay: PropTypes.number,
  children: PropTypes.node.isRequired,
};
